import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './shared/components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/components/footer/footer.component';
import { NavigationService } from './services/navigation.service';
import { Subscription } from 'rxjs';
import { AppInsightsService } from './services/app-insights.service';
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { ErrorBannerComponent } from './shared/components/error-banner/error-banner.component';
import { BrandService } from './services/brand.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoadingSpinnerComponent,
    ErrorBannerComponent
  ],
})
export class AppComponent implements OnDestroy {
  sub: Subscription;
  brandSub: Subscription;
  isAppEmbedded: boolean = false;
  title = 'windownation';
  private readonly applicationInsightsService = inject(AppInsightsService);

  constructor(
    private navigationService: NavigationService,
    private brandService: BrandService
  ) {
    this.sub = this.navigationService.getIsEmbedded().subscribe((res) => {
      this.isAppEmbedded = res;
    });

    this.brandSub = this.brandService.brand$.subscribe((brand) => {
      this.title = brand.key;
    });
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
    if (this.brandSub) this.brandSub.unsubscribe();
  }
}
